import { z } from 'zod';

export const CheckpointsSchema = z.object({
  checkpointId: z.string(),
  secrets: z.object({ index: z.number(), value: z.number() }).array(), // TODO: Extract out type, I think we use this elsewhere
});
export type CheckpointsData = z.infer<typeof CheckpointsSchema>;
